import React, { useState, useEffect, useRef } from 'react';
import SwitchTabs from '../../components/Dashboard/SwitchTabs';
import RadialChart from '../../components/Dashboard/RadialBarChart';
import LineChart from '../../components/Dashboard/LineChart';
import { getAllTeams } from '../../utils/services/teamsAPI';
import { DEFAULT_DATE_TIME_FORMAT } from '../../utils/helper';
import {
  Dashboard,
  Sidebar,
  Loader,
  Title,
  Filters,
  CardsContainer,
  Cards,
  Subtitle,
  FailureReasons,
  TemplatesList,
  ChartsSection,
  CloseIcon,
} from './newDashboardStyles.js';
import { getLastTwelveMonths } from '../../utils/javascript';
import {
  getShortMessage,
  getShortMessageChartData,
} from '../../utils/services/dashboardAPI';
import { Select, DatePicker, Icon, Spin } from 'antd';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import { SHORT_MESSAGE_DASHBOARD } from './TranslationValues';
import MessageFailedTransactions from './MessageFailedTransactions.js';

const { RangePicker } = DatePicker;
const { Option } = Select;
const NAMESPACES = ['SHORT_MESSAGE_DASHBOARD'];

const ShortMessageDashboard = props => {
  const { t } = props

  const size = {
    sideBarWidth: '40%',
    chartSectionWidth: '60%',
  };

  const today = new Date();
  const previous = new Date(today.getTime());
  const previousDate = previous.setDate(today.getDate() - 1);
  const dateFrom = moment(previousDate).format(DEFAULT_DATE_TIME_FORMAT);
  const dateTo = moment(today).format(DEFAULT_DATE_TIME_FORMAT);
  const [activeTab, setActiveTab] = useState(0);
  const [templatesView, setTemplatesView] = useState(false);
  const [viewType, setViewType] = useState(null);
  const [date, setDate] = useState({
    dateTo: dateTo,
    dateFrom: dateFrom,
  });
  const [teams, setTeams] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState('');
  const [data, setData] = useState(null);
  const [failurePercentage, setFailurePercentage] = useState({
    whatsappPercentage: 0,
    smsPercentage: 0,
    callPercentage: 0,
  });
  const [chartData, setChartData] = useState({
    averageSMSSuccess: [],
    averageSMSFailure: [],
    averageCallSuccess: [],
    averageCallFailure: [],
    averageWhatsappSuccess: [],
    averageWhatsappFailure: [],
  });
  const [failedIds, setFailedIds] = useState({ whatsapp: [], sms: [], call: [] });
  const [sideBarLoader, setSideBarLoader] = useState(false);
  const [chartSectionLoader, setChartSectionLoader] = useState(false);

  const initialRenderRef = useRef(true);

  const onDateChange = dates => {
    let startDate = moment(dates[0]).format(DEFAULT_DATE_TIME_FORMAT);
    let endDate = moment(dates[1]).format(DEFAULT_DATE_TIME_FORMAT);
    setDate({
      dateFrom: startDate,
      dateTo: endDate,
    });
  };

  const dashboardAPI = async () => {
    const payload = {
      dateFrom: date.dateFrom,
      dateTo: date.dateTo,
    };
    if(selectedTeam) {
      payload.teamId = selectedTeam;
    }
    try {
      setSideBarLoader(true);
      const APIs = [getShortMessage(payload)];
      if(initialRenderRef.current) {
        setChartSectionLoader(true);
        APIs.push(getAllTeams(), getShortMessageChartData());
        initialRenderRef.current = false;
      }
      const [statsApiResponse, teamApiResponse, chartDataApiResponse] = await Promise.allSettled(APIs);
      if(statsApiResponse) {
        setData(statsApiResponse.value.data);
        updateFailurePercentage(statsApiResponse.value.data);
      }
      if(teamApiResponse) {
        setTeams(teamApiResponse?.value?.data);
      }
      if(chartDataApiResponse) {
        chartDataAPI(chartDataApiResponse?.value);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setSideBarLoader(false);
      setChartSectionLoader(false);
    }
  };

  const getMonthIndex = (month) => {
    let counter = new Date().getMonth()+1;
    for(let i = 11; i >= 0; i--) {
      if(counter === month) {
        return i;
      }
      if(counter === 1) {
        counter = 12;
      } else {
        counter--;    
      }
    }
  }

  const chartDataAPI = (res) => {
        let smsSuccess = Array.from({ length: 12 }).fill(0);
        let smsFailure = Array.from({ length: 12 }).fill(0);
        let callSuccess = Array.from({ length: 12 }).fill(0);
        let callFailure = Array.from({ length: 12 }).fill(0);
        let whatsappSuccess = Array.from({ length: 12 }).fill(0);
        let whatsappFailure = Array.from({ length: 12 }).fill(0);

        res.data.map(element => {
          const index = getMonthIndex(element.month);
          smsSuccess[index] = element.averageSMSSuccess;
          smsFailure[index] = element.averageSMSFailure;
          callSuccess[index] = element.averageCallSuccess;
          callFailure[index] = element.averageCallFailure;
          whatsappSuccess[index] = element.averageWhatsappSuccess;
          whatsappFailure[index] = element.averageWhatsappFailure;
        });

        setChartData({
          averageSMSSuccess: smsSuccess,
          averageSMSFailure: smsFailure,
          averageCallSuccess: callSuccess,
          averageCallFailure: callFailure,
          averageWhatsappSuccess: whatsappSuccess,
          averageWhatsappFailure: whatsappFailure,
        });
  };

  useEffect(() => {
    dashboardAPI();
  }, [selectedTeam, date.dateFrom, date.dateTo]);


  useEffect(() => {
    updateFailurePercentage(data);
  }, [activeTab]);

  const updateFailurePercentage = (data) => {
    if (data) {
      const metrics = activeTab === 0 ? data.liveMetrics : data.sandboxMetrics;

      const calculatePercentage = (type) => {
        const failurePercentage =
          metrics[`failure${type}`] / (metrics[`total${type}`]) * 100;

        return isNaN(failurePercentage) ? 0 : Math.round(failurePercentage);
      };

      setFailurePercentage({
        whatsappPercentage: calculatePercentage('Whatsapp'),
        smsPercentage: calculatePercentage('Sms'),
        callPercentage: calculatePercentage('Call'),
      });

      setFailedIds({
        whatsapp: metrics.whatsappFailureIds,
        sms: metrics.smsfailureIds,
        call: metrics.callFailureIds,
      });
    }
  }

  const handleChange = value => {
    setSelectedTeam(value);
  };

  const fetchteams = () => {
    getAllTeams()
      .then(res => {
        setTeams(res.data);
      })
      .catch(err => {
        console.log(err);
      });
  };


  function disabledDate(current) {
    return current > moment() || current < moment().subtract(7, 'day');
  }

  const failureReasonPercentage = (count, total) => {
    const percentage = parseInt(count) / parseInt(total) * 100;
    return isNaN(percentage) ? 0 : Math.round(percentage);
  }

  return (
    <Dashboard>
      <Sidebar width={size.sideBarWidth}>
        {sideBarLoader && (
          <Loader>
            <Spin size={'large'} />
          </Loader>
        )}
        <Title height={'10%'}>{t(SHORT_MESSAGE_DASHBOARD.SHORT_MESSAGE_DASHBOARD_TITLE.key,SHORT_MESSAGE_DASHBOARD.SHORT_MESSAGE_DASHBOARD_TITLE.value)}</Title>
        <Filters height={'15%'}>
          <SwitchTabs
            items={[`${t(SHORT_MESSAGE_DASHBOARD.PUBLISHED_TAB_TITLE.key,SHORT_MESSAGE_DASHBOARD.PUBLISHED_TAB_TITLE.value)}`,
              `${t(SHORT_MESSAGE_DASHBOARD.TESTING_TAB_TITLE.key,SHORT_MESSAGE_DASHBOARD.TESTING_TAB_TITLE.value)}`,
              `${t(SHORT_MESSAGE_DASHBOARD.DRAFT_TAB_TITLE.key,SHORT_MESSAGE_DASHBOARD.DRAFT_TAB_TITLE.value)}`]}
            width={'360px'}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
          <Select
            showSearch
            style={{ minWidth: '28%' }}
            optionFilterProp="children"
            defaultValue={'All'}
            onChange={handleChange}
            filterOption={(input, option) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            <Option value="" selected>
              {t(SHORT_MESSAGE_DASHBOARD.ALL_TEMPLATE_CATEGORY_DROPDOWN_OPTION.key,SHORT_MESSAGE_DASHBOARD.ALL_TEMPLATE_CATEGORY_DROPDOWN_OPTION.value)}
            </Option>
            {teams.map(team => (
              <Option key={team.id} value={team.id}>
                {team.name}
              </Option>
            ))}
          </Select>
          <RangePicker
            disabledDate={disabledDate}
            inputReadOnly={true}
            allowClear={false}
            showTime={{
              hideDisabledOptions: true,
              defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('11:59:59', 'HH:mm:ss')],
            }}
            defaultValue={[moment().subtract(1, 'day'), moment()]}
            format="YYYY-MM-DD HH:mm:ss"
            onOk={e => onDateChange(e)}
          />
        </Filters>
        <CardsContainer height={'45%'}>
          <Cards
            id={4}
            templatesCount={true}
            animation={'popUp'}
            animationDelay={'400ms'}
            countFontSize={'1.1rem'}
            height={'31%'}
            width={'22%'}
            textColor={'#000'}
            bgColor={'#F9DF25'}
          >
            <h2 className="title">{t(SHORT_MESSAGE_DASHBOARD.WHATSAPP_CARD_TITLE.key,SHORT_MESSAGE_DASHBOARD.WHATSAPP_CARD_TITLE.value)}</h2>
            <h1 className="count">
              {activeTab == 0 ? (
                data === null ? (
                  <Spin tip="Loading" />
                ) : (
                  data?.liveMetrics?.totalWhatsapp
                )
              ) : data === null ? (
                <Spin tip="Loading" />
              ) : (
                  data?.sandboxMetrics?.totalWhatsapp
              )}
            </h1>
            <p className="subText">{t(SHORT_MESSAGE_DASHBOARD.WHATSAPP_CARD_SENT_LABEL.key,SHORT_MESSAGE_DASHBOARD.WHATSAPP_CARD_SENT_LABEL.value)}</p>
          </Cards>
          <Cards
            id={4}
            templatesCount={true}
            animation={'popUp'}
            animationDelay={'400ms'}
            countFontSize={'1.1rem'}
            height={'31%'}
            width={'22%'}
            textColor={'#000'}
            bgColor={'#F9DF25'}
          >
            <h2 className="title">{t(SHORT_MESSAGE_DASHBOARD.SMS_CARD_TITLE.key,SHORT_MESSAGE_DASHBOARD.SMS_CARD_TITLE.value)}</h2>
            <h1 className="count">
              {activeTab == 0 ? (
                data === null ? (
                  <Spin tip="Loading" />
                ) : (
                  data?.liveMetrics?.totalSms  
                )
              ) : data === null ? (
                <Spin tip="Loading" />
              ) : (
                data?.sandboxMetrics?.totalSms
              )}
            </h1>
            <p className="subText">{t(SHORT_MESSAGE_DASHBOARD.SMS_CARD_SENT_LABEL.key,SHORT_MESSAGE_DASHBOARD.SMS_CARD_SENT_LABEL.value)}</p>
          </Cards>
          <Cards
            id={4}
            templatesCount={true}
            animation={'popUp'}
            animationDelay={'400ms'}
            countFontSize={'1.1rem'}
            height={'31%'}
            width={'22%'}
            textColor={'#000'}
            bgColor={'#F9DF25'}
          >
            <h2 className="title">{t(SHORT_MESSAGE_DASHBOARD.PHONE_CALL_CARD_TITLE.key,SHORT_MESSAGE_DASHBOARD.PHONE_CALL_CARD_TITLE.value)}</h2>
            <h1 className="count">
              {activeTab == 0 ? (
                data === null ? (
                  <Spin tip="Loading" />
                ) : (
                  data?.liveMetrics?.totalCall  
                )
              ) : data === null ? (
                <Spin tip="Loading" />
              ) : (
                data?.sandboxMetrics?.totalCall
              )}
            </h1>
            <p className="subText">{t(SHORT_MESSAGE_DASHBOARD.PHONE_CALLS_CARD_SENT_LABEL.key,SHORT_MESSAGE_DASHBOARD.PHONE_CALLS_CARD_SENT_LABEL.value)}</p>
          </Cards>
          <Cards
            id={5}
            templatesCount={true}
            animation={'popUp'}
            animationDelay={'600ms'}
            height={'54%'}
            width={'fit-content'}
            bgColor={'#C9E260'}
          >
            <h2 className="title">{t(SHORT_MESSAGE_DASHBOARD.FAILURE_STATS_SECTION_TITLE.key,SHORT_MESSAGE_DASHBOARD.FAILURE_STATS_SECTION_TITLE.value)}</h2>
            <div className="shortMessageStats">
              <h4>{t(SHORT_MESSAGE_DASHBOARD.FAILURE_STATS_WHATSAPP_LABEL.key,SHORT_MESSAGE_DASHBOARD.FAILURE_STATS_WHATSAPP_LABEL.value)}</h4>
              <h3>
                {activeTab == 0 ? (
                  data === null ? (
                    <Spin tip="Loading" />
                  ) : (
                    data?.liveMetrics?.failureWhatsapp  
                  )
                ) : data === null ? (
                  <Spin tip="Loading" />
                ) : (
                  data?.sandboxMetrics?.failureWhatsapp
                )}
              </h3>
              <a
                onClick={() => {
                  setTemplatesView(true);
                  setViewType(0);
                }}
              >
                {t(SHORT_MESSAGE_DASHBOARD.VIEW_FAILED_WHATSAPP_TEMPLATES_TABLE_ACTION.key,SHORT_MESSAGE_DASHBOARD.VIEW_FAILED_WHATSAPP_TEMPLATES_TABLE_ACTION.value)}
              </a>
            </div>
            <RadialChart
              value={failurePercentage.whatsappPercentage}
              color={['#F25021']}
              textColor={'#000'}
            />
            <div className="shortMessageStats">
              <h4>{t(SHORT_MESSAGE_DASHBOARD.FAILURE_STATS_SMS_LABEL.key,SHORT_MESSAGE_DASHBOARD.FAILURE_STATS_SMS_LABEL.value)}</h4>
              <h3>
                {activeTab == 0 ? (
                  data === null ? (
                    <Spin tip="Loading" />
                  ) : (
                    data?.liveMetrics?.failureSms  
                  )
                ) : data === null ? (
                  <Spin tip="Loading" />
                ) : (
                  data?.sandboxMetrics?.failureSms
                )}
              </h3>
              <a
                onClick={() => {
                  setTemplatesView(true);
                  setViewType(1);
                }}
              >
                {t(SHORT_MESSAGE_DASHBOARD.VIEW_FAILED_SMS_TEMPLATES_TABLE_ACTION.key,SHORT_MESSAGE_DASHBOARD.VIEW_FAILED_SMS_TEMPLATES_TABLE_ACTION.value)}
              </a>
            </div>
            <RadialChart
              value={failurePercentage.smsPercentage}
              color={['#F25021']}
              textColor={'#000'}
            />
            <div className="shortMessageStats">
              <h4>{t(SHORT_MESSAGE_DASHBOARD.FAILURE_STATS_PHONE_CALL_LABEL.key,SHORT_MESSAGE_DASHBOARD.FAILURE_STATS_PHONE_CALL_LABEL.value)}</h4>
              <h3>
                {activeTab == 0 ? (
                  data === null ? (
                    <Spin tip="Loading" />
                  ) : (
                    data?.liveMetrics?.failureCall  
                  )
                ) : data === null ? (
                  <Spin tip="Loading" />
                ) : (
                  data?.sandboxMetrics?.failureCall
                )}
              </h3>
              <a
                onClick={() => {
                  setTemplatesView(true);
                  setViewType(2);
                }}
              >
                {t(SHORT_MESSAGE_DASHBOARD.VIEW_FAILED_PHONE_CALL_TEMPLATES_TABLE_ACTION.key,SHORT_MESSAGE_DASHBOARD.VIEW_FAILED_PHONE_CALL_TEMPLATES_TABLE_ACTION.value)}
              </a>
            </div>
            <RadialChart
              value={failurePercentage.callPercentage}
              color={['#F25021']}
              textColor={'#000'}
            />
          </Cards>
        </CardsContainer>
        <Subtitle height={'5%'}>{t(SHORT_MESSAGE_DASHBOARD.FAILURE_REASONS_SECTION_TITLE.key,SHORT_MESSAGE_DASHBOARD.FAILURE_REASONS_SECTION_TITLE.value)}</Subtitle>
        <FailureReasons height={'25%'}>
          <Cards
            animation={'fadeIn'}
            animationDelay={'400ms'}
            height={'120px'}
            width={'98px'}
            bgColor={'#FFF'}
          >
            <div className="icon"></div>
            <h2 className="text">{t(SHORT_MESSAGE_DASHBOARD.FAILURE_REASONS_WHATSAPP_COULD_NOT_DELIVER_CARD_TITLE.key,SHORT_MESSAGE_DASHBOARD.FAILURE_REASONS_WHATSAPP_COULD_NOT_DELIVER_CARD_TITLE.value)}</h2>
            <h1 className="percentage">
              {activeTab == 0 ? (
                data === null ? (
                  <Spin tip="Loading" />
                ) : (
                  failureReasonPercentage(data?.liveMetrics?.whatsappNotDeleivered, data?.liveMetrics?.totalWhatsapp)+'%'
                )
              ) : data === null ? (
                <Spin tip="Loading" />
              ) : (
                failureReasonPercentage(data?.sandboxMetrics?.whatsappNotDeleivered, data?.sandboxMetrics?.totalWhatsapp)+'%'
              )}
            </h1>
          </Cards>
          <Cards
            animation={'fadeIn'}
            animationDelay={'600ms'}
            height={'120px'}
            width={'98px'}
            bgColor={'#FFF'}
          >
            <div className="icon"></div>
            <h2 className="text">{t(SHORT_MESSAGE_DASHBOARD.FAILURE_REASONS_SMS_COULD_NOT_DELIVER_CARD_TITLE.key,SHORT_MESSAGE_DASHBOARD.FAILURE_REASONS_SMS_COULD_NOT_DELIVER_CARD_TITLE.value)}</h2>
            <h1 className="percentage">
              {activeTab == 0 ? (
                data === null ? (
                  <Spin tip="Loading" />
                ) : (
                  failureReasonPercentage(data?.liveMetrics?.smsNotDeleivered, data?.liveMetrics?.totalSms)+'%'  
                )
              ) : data === null ? (
                <Spin tip="Loading" />
              ) : (
                failureReasonPercentage(data?.sandboxMetrics?.smsNotDeleivered, data?.sandboxMetrics?.totalSms)+'%'
              )}
            </h1>
          </Cards>
          <Cards
            animation={'fadeIn'}
            animationDelay={'1s'}
            height={'120px'}
            width={'98px'}
            bgColor={'#FFF'}
          >
            <div className="icon"></div>
            <h2 className="text">{t(SHORT_MESSAGE_DASHBOARD.FAILURE_REASONS_PHONE_CALLS_NOT_PICKED_CARD_TITLE.key,SHORT_MESSAGE_DASHBOARD.FAILURE_REASONS_PHONE_CALLS_NOT_PICKED_CARD_TITLE.value)}</h2>
            <h1 className="percentage">
              {activeTab == 0 ? (
                data === null ? (
                  <Spin tip="Loading" />
                ) : (
                  failureReasonPercentage(data?.liveMetrics?.callNotPickedUp, data?.liveMetrics?.totalCall)+'%'  
                )
              ) : data === null ? (
                <Spin tip="Loading" />
              ) : (
                failureReasonPercentage(data?.sandboxMetrics?.callNotPickedUp, data?.sandboxMetrics?.totalCall)+'%'
              )}
            </h1>
          </Cards>
        </FailureReasons>
      </Sidebar>
      <ChartsSection width={size.chartSectionWidth}>
        {chartSectionLoader && (
          <Loader>
            <Spin size={'large'} />
          </Loader>
        )}
        <LineChart
          title={t(SHORT_MESSAGE_DASHBOARD.USAGE_TREND_CHART_TITLE.key,SHORT_MESSAGE_DASHBOARD.USAGE_TREND_CHART_TITLE.value)}
          description={t(SHORT_MESSAGE_DASHBOARD.USAGE_TREND_CHART_DESCRIPTION.key,SHORT_MESSAGE_DASHBOARD.USAGE_TREND_CHART_DESCRIPTION.value)}
          height={250}
          width={370}
          colors={['#4dffd2', '#ffb84d', '#ff1a8c']}
          categories={getLastTwelveMonths()}
          series={[
            { name: `${t(SHORT_MESSAGE_DASHBOARD.USAGE_TREND_CHART_WHATSAPP_COLOR_LABEL.key,SHORT_MESSAGE_DASHBOARD.USAGE_TREND_CHART_WHATSAPP_COLOR_LABEL.value)}`, data: chartData.averageWhatsappSuccess },
            { name: `${t(SHORT_MESSAGE_DASHBOARD.USAGE_TREND_CHART_SMS_COLOR_LABEL.key,SHORT_MESSAGE_DASHBOARD.USAGE_TREND_CHART_SMS_COLOR_LABEL.value)}`, data: chartData.averageSMSSuccess },
            { name: `${t(SHORT_MESSAGE_DASHBOARD.USAGE_TREND_CHART_PHONE_CALL_COLOR_LABEL.key,SHORT_MESSAGE_DASHBOARD.USAGE_TREND_CHART_PHONE_CALL_COLOR_LABEL.value)}`, data: chartData.averageCallSuccess },
          ]}
        />
        <LineChart
          title={t(SHORT_MESSAGE_DASHBOARD.MESSAGING_STABILITY_CHART_TITLE.key,SHORT_MESSAGE_DASHBOARD.MESSAGING_STABILITY_CHART_TITLE.value)}
          description={t(SHORT_MESSAGE_DASHBOARD.MESSAGING_STABILITY_CHART_DESCRIPTIO.key,SHORT_MESSAGE_DASHBOARD.MESSAGING_STABILITY_CHART_DESCRIPTIO.value)}
          height={250}
          width={370}
          colors={['#66778F', '#D3DB9F', '#55BCB8']}
          categories={getLastTwelveMonths()}
          series={[
            { name: `${t(SHORT_MESSAGE_DASHBOARD.MESSAGING_STABILITY_CHART_WHATSAPP_COLOR_LABEL.key,SHORT_MESSAGE_DASHBOARD.MESSAGING_STABILITY_CHART_WHATSAPP_COLOR_LABEL.value)}`, data: chartData.averageWhatsappFailure },
            { name: `${t(SHORT_MESSAGE_DASHBOARD.MESSAGING_STABILITY_CHART_SMS_COLOR_LABEL.key,SHORT_MESSAGE_DASHBOARD.MESSAGING_STABILITY_CHART_SMS_COLOR_LABEL.value)}`, data: chartData.averageSMSFailure },
            { name: `${t(SHORT_MESSAGE_DASHBOARD.MESSAGING_STABILITY_CHART_PHONE_CALL_COLOR_LABEL.key,SHORT_MESSAGE_DASHBOARD.MESSAGING_STABILITY_CHART_PHONE_CALL_COLOR_LABEL.value)}`, data: chartData.averageCallFailure },
          ]}
        />
      </ChartsSection>
      <TemplatesList screenWidth={size.chartSectionWidth} templatesView={templatesView}>
        <CloseIcon
          onClick={() => {
            setTemplatesView(false);
          }}
        >
          <Icon type="close" />
        </CloseIcon>
        <MessageFailedTransactions
          viewType={viewType}
          failedIds={failedIds}
          isTableVisible={templatesView}
        />
      </TemplatesList>
    </Dashboard>
  );
};

export default withTranslation(NAMESPACES)(ShortMessageDashboard);
